<div class="data-sect">
    <h3>Product Video List</h3>
    <hr>
    <table
        class="table"
        [svData]="data"
        #sv="svDataTable"
        [svRowsOnPage]="pageSize"
        *ngIf="data && data.length > 0"
    >
        <thead>
            <tr>
                <th>Scheme</th>
                <th class="text-center">Title</th>
                <th class="text-center">URL</th>
                <th class="text-center">Last Updated On</th>
                <th class="text-center">Edit</th>
                <th class="text-center">Delete</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let item of sv.data">
                <td>{{ item.schemeName }}</td>
                <td class="text-center">{{ item.videoName }}</td>
                <td>{{ item.videoUrl }}</td>
                <td class="text-center">{{ item.modificationDate }}</td>
                <td class="text-center">
                    <img
                        src="assets/icons/edit.png"
                        class="cursor-pointer"
                        (click)="onEdit(item)"
                    >
                </td>
                <td class="text-center">
                    <img
                        src="assets/icons/delete_icon.png"
                        class="cursor-pointer"
                        (click)="deleteData(item.id)"
                    >
                </td>
            </tr>
        </tbody>
        <tfoot *ngIf="data?.length > pageSize">
            <tr>
                <td
                    colspan="5"
                    class="center-paginator"
                >
                    <sv-bootstrap-paginator></sv-bootstrap-paginator>
                </td>
            </tr>
        </tfoot>
    </table>







    <div *ngIf="data?.length === 0">
        <p class="no-data">No data found</p>
    </div>
</div>
